import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'home-menu',
    templateUrl: './home-menu.component.html',
    styleUrls: [
       './home-menu.component.scss',
       // './role-request/role-request-home/role-request-home.component.css'
    ],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeMenuComponent implements OnInit {
  private router = inject(Router);
    routeFlag = false;

  ngOnInit(): void {
    this.routeFlag = false;
  }

  public onTileClick = (e) => {
  }

  navigateProfileSearch() {
    this.routeFlag = true;
    this.router.navigateByUrl('profile-management/profile-search');
  }

  navigateChangeSearch() {
    this.routeFlag = true;
    this.router.navigateByUrl('profile-management/change/change-search');
  }
  
}
